import { ArrowLeftRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/store/authStore'
import { isDualRole } from '@/utils/roleUtils'

export function ModeSwitcher() {
  const { user, currentMode, setCurrentMode } = useAuthStore()
  const navigate = useNavigate()
  const { t } = useTranslation('nav')

  // 듀얼 역할이 아니면 렌더링하지 않음
  if (!isDualRole(user?.role)) return null

  const handleSwitch = () => {
    const newMode = currentMode === 'admin' ? 'learner' : 'admin'
    setCurrentMode(newMode)
    navigate(newMode === 'admin' ? '/admin' : '/my/courses')
  }

  return (
    <button
      onClick={handleSwitch}
      className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-700 transition-colors text-sm font-medium"
    >
      <ArrowLeftRight className="w-4 h-4" />
      <span>
        {currentMode === 'admin' ? t('modeSwitcher.toLearner') : t('modeSwitcher.toAdmin')}
      </span>
    </button>
  )
}
